export interface IEncuestaResumen {
    id: number,
    pregunta: string,
    opciones: IOpcionEncuesta[],
}

export interface IOpcionEncuesta {
    opcion: string,
    respuesta: string,
    votos: number,
    porcentaje: number,
}

export class OpcionEncuesta implements IOpcionEncuesta {
    /* STATIC */
    public static build(data: IOpcionEncuesta): OpcionEncuesta {
        return new this({
            opcion: data.opcion,
            respuesta: data.respuesta,
            votos: data.votos,
            porcentaje: data.porcentaje,
        });
    }

    /* INSTANCE */
    public get opcion(): string     { return this.data.opcion; }
    public get respuesta(): string  { return this.data.respuesta; }
    public get votos(): number      { return this.data.votos; }
    public get porcentaje(): number { return this.data.porcentaje; }

    public set opcion(opcion: string)         { this.data.opcion = opcion; }
    public set respuesta(respuesta: string)   { this.data.respuesta = respuesta; }
    public set votos(votos: number)           { this.data.votos = votos; }
    public set porcentaje(porcentaje: number) { this.data.porcentaje = porcentaje; }

    public constructor(protected data: IOpcionEncuesta) {

    }

    public toJSON(): IOpcionEncuesta {
        return {
            opcion: this.data.opcion,
            respuesta: this.data.respuesta,
            votos: this.data.votos,
            porcentaje: this.data.porcentaje,
        };
    }
}

export interface IEncuesta extends IEncuestaResumen {
    activa: boolean,
    helvetia: boolean,
    fecha_creacion: string,
    fecha_inicio?: string,
    fecha_fin?: string,
}

export interface IEncuestaClase {
    id: number,
    pregunta: string,
    opciones: OpcionEncuesta[],
    activa: boolean,
    helvetia: boolean,
    fecha_creacion: Date,
    fecha_inicio?: Date,
    fecha_fin?: Date,
}

export class Encuesta implements IEncuestaClase {
    /* STATIC */
    public static build(data: IEncuesta): Encuesta {
        return new this({
            id: data.id,
            pregunta: data.pregunta,
            opciones: data.opciones.map(actual=>OpcionEncuesta.build(actual)),
            activa: data.activa,
            helvetia: data.helvetia,
            fecha_creacion: new Date(data.fecha_creacion),
            fecha_inicio: data.fecha_inicio!=undefined?new Date(data.fecha_inicio):undefined,
            fecha_fin: data.fecha_fin!=undefined?new Date(data.fecha_fin):undefined,
        });
    }

    /* INSTANCE */
    public get id(): number                   { return this.data.id; }
    public get pregunta(): string             { return this.data.pregunta; }
    public get opciones(): OpcionEncuesta[]   { return this.data.opciones; }
    public get activa(): boolean              { return this.data.activa; }
    public get helvetia(): boolean            { return this.data.helvetia; }
    public get fecha_creacion(): Date         { return this.data.fecha_creacion; }
    public get fecha_inicio(): Date|undefined { return this.data.fecha_inicio; }
    public get fecha_fin(): Date|undefined    { return this.data.fecha_fin; }

    public set id(id: number)                             { this.data.id = id; }
    public set pregunta(pregunta: string)                 { this.data.pregunta = pregunta; }
    public set opciones(opciones: OpcionEncuesta[])       { this.data.opciones = opciones; }
    public set activa(activa: boolean)                    { this.data.activa = activa; }
    public set helvetia(helvetia: boolean)                { this.data.helvetia = helvetia; }
    public set fecha_creacion(fecha_creacion: Date)       { this.data.fecha_creacion = fecha_creacion; }
    public set fecha_inicio(fecha_inicio: Date|undefined) { this.data.fecha_inicio = fecha_inicio; }
    public set fecha_fin(fecha_fin: Date|undefined)       { this.data.fecha_fin = fecha_fin; }

    protected constructor(protected data: IEncuestaClase) {
    }

    public toJSON(): IEncuesta {
        return {
            id: this.data.id,
            pregunta: this.data.pregunta,
            opciones: this.data.opciones.map(actual=>actual.toJSON()),
            activa: this.data.activa,
            helvetia: this.data.helvetia,
            fecha_creacion: this.data.fecha_creacion.toISOString(),
            fecha_inicio: this.data.fecha_inicio?.toISOString(),
            fecha_fin: this.data.fecha_fin?.toISOString(),
        };
    }
}
